import * as city from 'src/api/city'
import {
  GET_ALL_CITY
} from 'src/store/mutation-types'

const getAllCity = ({commit, dispatch}, params) => {
  dispatch('toggleLoadding', true, {root: true})
  city.getAllCity(params).then(response => {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_ALL_CITY, response.data)
    } else {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_ALL_CITY, [])
    }
  })
}

export default{
  getAllCity
}



// WEBPACK FOOTER //
// ./src/components/city/store/actions.js